import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component ChecklistIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <ChecklistIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <ChecklistIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ChecklistIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ChecklistIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        d="M5 16a3 3 0 110 6 3 3 0 010-6zm16 2a1 1 0 010 2H11a1 1 0 010-2h10zM5 18a1 1 0 100 2 1 1 0 000-2zm0-9a3 3 0 110 6 3 3 0 010-6zm16 2a1 1 0 010 2H11a1 1 0 010-2h10zM5 11a1 1 0 100 2 1 1 0 000-2zm0-9a3 3 0 110 6 3 3 0 010-6zm16 2a1 1 0 010 2H11a1 1 0 010-2h10zM5 4a1 1 0 100 2 1 1 0 000-2z"
        fillRule="evenodd"
      />
    </svg>
  )
);
ChecklistIcon.displayName = "ChecklistIcon";
export default ChecklistIcon;
